<p-table [value]="paginationResult.entities" [lazy]="true" (onLazyLoad)="loadData($event)"
    [rows]="paginationRequest.pageSize" [totalRecords]="paginationResult.filteredEntities"
    [rowsPerPageOptions]="[5]" [paginator]="true" [(selection)]="selectedEntities" [loading]="loading"
    [rowHover]="true" [showCurrentPageReport]="true" [autoLayout]="true" dataKey="name"
    currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}" class="custom-table"
    styleClass="p-datatable-striped">

    <!-- #region TABLE TITLE DEFINITION -->
    <ng-template pTemplate="caption">
        <div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title">
            {{'tableManagement.renewalFiles.files' | translate}}
        </div>
    </ng-template>
    <!-- #endregion TABLE TITLE DEFINITION -->

    <!-- #region TABLE COLUMN DEFINITION -->
    <ng-template pTemplate="header">
        <tr>

            <!-- DATE -->
            <th>
                <div class='d-flex align-items-center h-100'>

                    <!-- COLUMN TITLE -->
                    <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
                        {{'tableManagement.renewalFiles.date' | translate}}
                    </div>                
                </div>
            </th>

            <!-- FILENAME -->
            <th>
                <div class='d-flex align-items-center h-100'>

                    <!-- COLUMN TITLE -->
                    <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
                        {{'tableManagement.renewalFiles.name' | translate}}
                    </div>                
                </div>
            </th>
            
            <!-- FINISHED -->
            <th>
                <div class='d-flex align-items-center h-100'>

                    <!-- COLUMN TITLE -->
                    <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
                        {{'tableManagement.renewalFiles.finished' | translate}}
                    </div>                
                </div>
            </th>
        </tr>
    </ng-template>


    <!-- #endregion TABLE COLUMN DEFINITION -->

    <!-- #region TABLE BODY -->
    <ng-template pTemplate="body" let-entity>
        <tr class="p-selectable-row custom-rows" (dblclick)="editDialog(entity)">

            <!-- DATE -->
            <td>
                {{ entity.dateFileUpdate | date: 'dd/MM/yyyy'}}
            </td>

            <!-- NAME -->
            <td>
                {{entity.file?.name}}
            </td>

            <td>
                {{ entity.finished ? ('tableManagement.renewalFiles.yes' | translate) : 'NO' }}
            </td>
            
        </tr>

    </ng-template>
    <!-- #endregion TABLE BODY -->

    <!-- #region TABLE EMPTY MESSAGE -->
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="2" class="p-0">
                <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
                    {{ 'table.tableEmptyMessage' | translate }}!
                </div>
            </td>
        </tr>
    </ng-template>
    <!-- #endregion TABLE EMPTY MESSAGE -->

    <!-- #region TABLE FOOTER -->
    <ng-template pTemplate="footer">
        <tr>
            <td colspan="2" class="p-0">
                
            </td>
        </tr>
    </ng-template>
    <!-- #endregion TABLE FOOTER -->

</p-table>

